import { render, staticRenderFns } from "./ProductStructureTree.vue?vue&type=template&id=d9445a48&scoped=true&"
import script from "./ProductStructureTree.vue?vue&type=script&lang=js&"
export * from "./ProductStructureTree.vue?vue&type=script&lang=js&"
import style0 from "./ProductStructureTree.vue?vue&type=style&index=0&id=d9445a48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9445a48",
  null
  
)

export default component.exports